const languages = ["en", "da"] as const
export type TLanguage = (typeof languages)[number]
export function getAllLanguages() {
    return languages
}
